import { DisplayScreen } from '@oolio-group/domain';
import { useStableList } from '../../hooks/useStableList/useStableList';

/**
 * The session object is replaced on every emit, so a plain useMemo on `config`
 * hands the carousel a new array each time and restarts playback mid-order.
 * Key the list on the uris instead, so it only changes when the media does.
 */
export function useMediaItems<T>(
  config: DisplayScreen | undefined,
  resolveItems: (config?: DisplayScreen) => T[],
  toKey: (item: T) => string,
): T[] {
  return useStableList(resolveItems(config), toKey);
}
